import React from "react";
import { RiCompassDiscoverLine } from "react-icons/ri";
import { AiOutlineAntDesign } from "react-icons/ai";
import { ReactComponent as LaunchIcon } from "../../assets/launch.svg";
import { ReactComponent as DefineIcon } from "../../assets/define.svg";
import { ReactComponent as IdeaIcon } from "../../assets/ideaicon.svg";
import { ReactComponent as DesignIcon } from "../../assets/designicon.svg";

const WorkFlow = () => {
  return (
    <div className="w-full bg-gray-800 " id="workflow">
      <section className="max-w-6xl lg:max-w-full lg:px-12  mx-auto px-5 py-6 ">
        <div className="text-center pb-6">
          <h1 className="font-bold text-2xl md:text-3xl lg:text-4xl font-heading text-white">
            Work flow
          </h1>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="w-full bg-gray-900 rounded-lg shadow-md p-12  flex flex-col justify-center items-center transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110">
            <div className="mb-8 text-red-400 text-2xl">
              <RiCompassDiscoverLine />
            </div>
            <div className="text-center">
              <p className="text-xl text-white font-bold mb-2">Discover</p>
              <p className="text-base text-gray-400 font-normal ">
                I conduct user research to identify the problem I want to solve.
              </p>
            </div>
          </div>
          <div className="w-full bg-gray-900 rounded-lg sahdow-lg p-12 flex flex-col justify-center items-center transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110">
            <div className="mb-8 text-red-400 text-2xl">
              <DefineIcon />
            </div>
            <div className="text-center">
              <p className="text-xl text-white font-bold mb-2">Define</p>
              <p className="text-base text-gray-400 font-normal">
                I brainstorm possible desing solution to identified problem.
              </p>
            </div>
          </div>
          <div className="w-full bg-gray-900 rounded-lg sahdow-lg p-12 flex flex-col justify-center items-center transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110">
            <div className="mb-8 text-red-400 text-2xl">
              <IdeaIcon />
            </div>
            <div className="text-center">
              <p className="text-xl text-white font-bold mb-2">Ideate</p>
              <p className="text-base text-gray-400 font-normal">
                I create wireframe and sketch of the product I'm about to doing.
              </p>
            </div>
          </div>
          <div className="w-full bg-gray-900 rounded-lg sahdow-lg p-12 flex flex-col justify-center items-center transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110">
            <div className="mb-8 text-red-400 text-2xl">
              <DesignIcon />
            </div>
            <div className="text-center">
              <p className="text-xl text-white font-bold mb-2">Design</p>
              <p className="text-base text-gray-400 font-normal">
                I transform wireframe into applets that embedded on web browser.
              </p>
            </div>
          </div>
          <div className="w-full bg-gray-900 rounded-lg sahdow-lg p-12 flex flex-col justify-center items-center transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110">
            <div className="mb-8 text-red-400 text-2xl">
              <AiOutlineAntDesign />
            </div>
            <div className="text-center">
              <p className="text-xl text-white font-bold mb-2">Develop</p>
              <p className="text-base text-gray-400 font-normal">
                I create high fidelity design and prototype the screen
              </p>
            </div>
          </div>
          <div className="w-full bg-gray-900 rounded-lg sahdow-lg p-12 flex flex-col justify-center items-center transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110">
            <div className="mb-8 text-red-400 text-2xl">
              <LaunchIcon />
            </div>
            <div className="text-center">
              <p className="text-xl text-white font-bold mb-2">Implement</p>
              <p className="text-base text-gray-400 font-normal">
                After, designing I deliver my prototype for implementations.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WorkFlow;
